<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:26:30
 -->
<!--  -->
<template>
  <basicContainer>
    <div class="announcementManage">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="根据角色配置" name="first"></el-tab-pane>
        <el-tab-pane label="根据用户配置" name="second"></el-tab-pane>
      </el-tabs>
      <!-- 主数据表 -->
      <easyCruds ref="mainTable" :tableInfo="mainTable" @mainTableReload="mainTableReload" @editRow="editRow"
        @beforeEditFunctionName="beforeEditFunctionName">
      </easyCruds>

    </div>
  </basicContainer>
</template>

<script>
export default {
  data() {
    return {
      roleTypeStr: '',
      roleObj: '',
      activeName: 'first',
      mainTable: {
        buttonSetting: {
          allowEdit: true,
          allowView: true,
          allowDelete: false,
          beforeEditFunctionName: 'beforeEditFunctionName',
          editButtonArray: [{
            clickEvent: 'editRow',
            buttonName: '保存',
            type: 'primary',
            loading: false,
            validate: false
          }]
        },
        header: {
          title: '栏目权限管理'
        },
        table: {
          loading: false,
          height: 550,
          stripe: true,
          conditionLabelWidth: '',
          selection: true,
          index: false,
          columns: [{
            prop: 'code',
            label: '编号|工号',
            isSearchCondition: true,
            type: 'input',
            span: 12,
            width: 100,
            disabled: [true, true, true]
          }, {
            prop: 'name',
            label: '名称',
            isSearchCondition: true,
            type: 'input',
            width: 130,
            disabled: [true, true, true]
          }, {
            prop: 'roleName',
            label: '权限名称',
            width: 300,
            isSearchCondition: true,
            type: 'select',
            multiple: true,
            view: [false, false, false],
            dicData: []

          }, {
            prop: 'roleId',
            label: '权限名称',
            width: 300,
            isSearchCondition: false,
            showInTable: false,
            type: 'select',
            multiple: true,
            required: true,
            dicData: []

          }, {
            prop: 'updateTime',
            label: '更新时间',
            width: 150,
            view: [false, false, false]
          }, {
            prop: 'updateUserName',
            label: '更新人',
            width: 150,
            view: [false, false, false]

          }, {
            prop: 'status',
            label: '状态',
            isTag: true,
            isSearchCondition: true,
            type: 'select',
            width: 130,
            dicData: [{
              label: '启用',
              value: '1'
            }, {
              label: '未启用',
              value: '0'
            }],
            tagFilter: function (e) {
              if (e === '1') {
                return {
                  data: '启用',
                  type: 'primary'
                }
              } else if (e === '0') {
                return {
                  data: '未启用',
                  type: 'warning'
                }
              } else {
                return {
                  data: '未知状态',
                  type: 'danger'
                }
              }
            },
            required: true,
          }],
          operation: {
            width: '180'

          },
          tableData: [],
          paging: {
            currentPage: 1,
            pageSizes: [10, 15, 20, 25],
            pageSize: 10,
            total: 0
          },
          reload: 'mainTableReload',
          reloadConditions: {}

        }

      }
    }
  },

  mounted() {
    this.mainTableReload({ pageNum: 1, pageSize: 10, roleType: 'role' })
    setTimeout(() => {
      this.getJurisdiction()
    }, 1000)
  },
  methods: {
    handleClick: function () {
      if (this.activeName == "second") {
        this.mainTableReload({ pageNum: 1, pageSize: 10, roleType: 'person' })
      } else if (this.activeName == "first") {
        this.mainTableReload({ pageNum: 1, pageSize: 10, roleType: 'role' })
      }

    },
    mainTableReload: function (params) {
      let obj = {}
      obj.code = params.code
      obj.name = params.name
      if (params.roleName != undefined) {
        obj.roleId = params.roleName.join(',')
      }

      obj.status = params.status
      obj.roleType = params.roleType
      this.mainTable.table.loading = true
      this.$http.post('/base/noticeNew/role/query', {
        "entity": obj,
        "orderItemList": [
          {
            "asc": true,
            "column": ""
          }
        ]
      }, {
        params
      }).then(
        response => {
          this.mainTable.table.loading = false
          // 成功之后的数据
          this.mainTable.table.tableData = response.data.records
          this.mainTable.table.paging.total = response.data.total || response.data.records.length
          return true
        }
      ).catch(
        error => {
          this.mainTable.table.loading = false
          this.$message.error(error.msg)
        }
      )
    },
    beforeEditFunctionName: function (row, type, callback) {
      if (row.roleId != null && row.roleName != null) {
        row.roleName = row.roleName.split(',')
        row.roleId = row.roleId.split(',')
      }
      callback(row)
    },
    editRow: function (row, done, errorDone, optionType) {
      let that = this
      let currentValue = ''
      let index = 0
      let newArr = []
      that.roleTypeStr = row.roleType
      row.roleId.forEach(function (currentValue, index, arr) {
        currentValue = currentValue
        index = index
        that.roleObj.forEach(function (val, i, array) {
          if (currentValue == val.value) {
            newArr.push(val.label)
          }
        });
      });
      row.roleName = []
      row.roleName = newArr
      row.roleId = row.roleId.join(',')
      row.roleName = row.roleName.join(',')
      that.$http.post('/base/noticeNew/role/update', row).then(response => {
        that.$message.success('更新成功') && done()
        let objParams = that.$refs.mainTable.getReloadConditions()
        objParams.roleType = that.roleTypeStr
        that.mainTableReload(objParams)
      }).catch(error => {
        that.$message.error(error.msg) && errorDone()
      })
    },
    getJurisdiction: function () {
      this.$http.post('/base/noticeNew/type/list', {
        "entity": {
        },
        "orderItemList": [
          {
            "asc": true,
            "column": "id"
          }
        ]
      }).then(response => {
        let result = []
        response.data.forEach(element => {
          result.push({
            label: element.name,
            value: element.code
          })
        })
        this.$refs.mainTable.setColumnSeting('roleName', 'dicData', result)
        this.$refs.mainTable.setColumnSeting('roleId', 'dicData', result)
        this.roleObj = result
        console.log(result)
      }).catch(error => {
        this.$message.error(error.msg)
      })

    }
  }
}
</script>

<style lang='scss'>
.quill-editor {
  height: 300px;
}
</style>
<style lang='scss' scoped>
:deep(.el-tabs__header) {
  margin-bottom: 0;
}
:deep(.el-card.is-always-shadow),
:deep(.el-card.is-hover-shadow:focus),
:deep(.el-card.is-hover-shadow:hover) {
  box-shadow: none;
}
:deep(.el-tabs__content),
:deep(.el-tabs--card > .el-tabs__header) {
  border: 0;
}
:deep(.avue-crud) {
  width: 100%;
  border: 1px solid #e4e7ed;
}
</style>
